import { findLast } from "~/tools/find-last";
import { type Impulse, useScoped } from "~/tools/impulse";
import { isPresent } from "~/tools/is-present";
import { map } from "~/tools/map";
import { pipe } from "~/tools/pipe";
import { useRequiredContext } from "~/tools/use-required-context";

import type { TimeRange } from "../../../app/state/view/timeline/TimeRange";

import { ExplorationDrawerStateContext } from "./_exploration-drawer-state-context";

export function useNearestMetricsDrawerTimeRange(): undefined | Impulse<TimeRange> {
	const { drawers } = useRequiredContext(ExplorationDrawerStateContext, {
		providerName: "ExplorationDrawerStateProvider",
	});

	return useScoped(
		(scope) =>
			pipe(
				drawers.getValue(scope),
				map(({ metrics, boundMetrics }) => metrics?.timeRange ?? boundMetrics?.timeRange),
				findLast(isPresent),
			),
		[drawers],
	);
}
